import { Constants } from "@eagerdog/constants";
import { IShow } from "@eagerdog/interfaces";
import { IEventRegisterRow } from "../../../services/helper.service.js";

export namespace ObedienceShowNGo {
  const ALL_LEVELS: string[] = [
    Constants.dog_class_element_level.obedience_show_n_go_beginner_novice,
    Constants.dog_class_element_level.obedience_show_n_go_novice,
    Constants.dog_class_element_level.obedience_show_n_go_open,
    Constants.dog_class_element_level.obedience_show_n_go_utility,
  ];

  // Only show a level's row if it's checked/configured in the Create/Edit Show setup
  const isElementAvailable = (show: IShow | undefined, level: string): boolean => {
    if (!show?.show_elements) return true; // If no show provided, show all options
    return show.show_elements.some((se) => se.show_element === level);
  };

  export const getForm = (show?: IShow): IEventRegisterRow[] => {
    return ALL_LEVELS
      .filter((level) => isElementAvailable(show, level))
      .map((level) => ({
        // Allows a dog to enter the same class multiple times (e.g. run Novice
        // several times at different available timeslots) via the "+" button.
        allowDuplicates: true,
        inputs: [{
          type: "dropdown",
          label: level,
          options: [
            { value: "None", id: "None" },
            { value: level, id: level }
          ]
        }]
      }));
  };
}
